import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { canUseDOM } from 'exenv';
import Ad from '../ad/ad';
import {
  PostHero,
  PostShort,
  PostVideo,
  PostDefault,
  ListArticle
  // MostCreativePeopleArticle,
} from './layouts';

import BWI2020 from '../../containers/pages/list_landers/bwi-2020';
import IBD2020 from '../../containers/pages/list_landers/ibd-2020';
import { isAdvertorial } from '../advertorial/advertorial';
import pressboard from '../../../client/utils/third_party_trackers/pressboard';
import Sticky from 'react-stickynode';
import MostCreativePeopleArticle from './layouts/mcp';

export default class PostsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stickyOffset: 109
    };

    this.resize = this.resize.bind(this);
  }

  componentWillMount() {
    if (
      this.props.updateCorrelator &&
      canUseDOM &&
      window.googletag &&
      window.googletag.pubadsReady
    ) {
      window.googletag.pubads().updateCorrelator();
    }
  }

  componentDidMount() {
    this.rendered = true;
    this.renderTrackers();
    // let compensateForNewsletter;
    window.addEventListener('resize', this.resize.bind(this));
    // if (!window.localStorage.getItem('hide-newsletter-signup-topnav')) {
    //   this.setState({compensateForNewsletter: true})
    //   compensateForNewsletter = true;
    //   // this.onRemove(this.getNewsLetter(),() => {this.setState({compensateForNewsletter: false})})
    // }
    this.resize();
  }

  shouldComponentUpdate() {
    const { props, rendered } = this;
    // initialPageLoad is needed for the first post to enable sticky ads.
    const isInitLoad = get(props, 'config.initialPageLoad');

    return !rendered || isInitLoad;
  }

  resize() {
    let stickyOffset = 109;
    if (window.innerWidth < 640) {
      stickyOffset = 0;
    } else if (window.innerWidth < 767) {
      stickyOffset = 50;
    }
    if (stickyOffset !== this.state.stickyOffset) {
      this.setState({ stickyOffset });
      this.forceUpdate();
    }
  }

  isAdvertorialFestival(tags) {
    let foundTag = false;
    tags.forEach(tagData => {
      if (get(tagData, 'name', '') === '_advertorial_festival') {
        foundTag = true;
      }
    });
    return foundTag;
  }

  renderTrackers() {
    const postId = get(this.props.posts, '[0].id', 0);
    if (postId === 40504669 || postId === 40537786) {
      pressboard();
    }
  }

  renderTrackerField() {
    const { posts } = this.props;

    const customScriptData = get(posts, '[0].customFields.custom_script');
    const customScriptExpiration = get(posts, '[0].customFields.expiration');

    if (customScriptData && customScriptExpiration === false) {
      return <div dangerouslySetInnerHTML={{ __html: customScriptData }} />;
    }
    return '';
  }

  renderTopAds(firstPost, isList) {
    if (isList) return false;

    const { isFirstPost, combinedAdModel, pageNum } = this.props;
    combinedAdModel.readTime = get(firstPost, 'readTime');
    combinedAdModel.pageNum = pageNum;
    const fullPageCeros = get(
      firstPost,
      'customFields.full_page_ceros_embed',
      false
    );

    const adName = isFirstPost ? 'flexiblepushdown' : 'flexiblebillboard';
    const region = isFirstPost ? 'articletop' : 'articlescroll';

    return (
      <div className="post__article-top-ad-wrapper">
        <Ad
          {...combinedAdModel}
          name={adName}
          region={region}
          ceros={fullPageCeros}
        />
        <Ad {...combinedAdModel} name="mobileleaderboard" region={region} />
      </div>
    );
  }

  renderTemplate(firstPost, advertorial, isList) {
    const isMCP = get(firstPost, 'customFields.show_mcp_list', false);

    if (isList) {
      if (firstPost.customFields && firstPost.customFields.select_the_list) {
        switch (firstPost.customFields.select_the_list) {
          case 'bwi2020':
            return <BWI2020 {...this.props} advertorial={advertorial} />;

          case 'ibd2020':
            return <IBD2020 {...this.props} advertorial={advertorial} />;

          default:
            return <ListArticle {...this.props} advertorial={advertorial} />;
        }
      } else {
        return <ListArticle {...this.props} advertorial={advertorial} />;
      }
    } else if (isMCP) {
      return (
        <MostCreativePeopleArticle {...this.props} advertorial={advertorial} />
      );
    }
    // STYLE GUIDE POST: /pvw/40400521/style-guide-for-fast-company-posts-in-2017
    switch (firstPost.layout) {
      // Poster: 3021050/leadership-lessons-from-the-us-army-in-afghanistan
      // or Slideshow:
      // or Video:
      case 'hero':
        return <PostHero {...this.props} advertorial={advertorial} />;
      // 40538300/facebook-comes-to-the-realization-that-one-feed-is-better-than-two
      case 'short':
        return <PostShort {...this.props} advertorial={advertorial} />;
      // video/your-jean-jacket-of-the-future-could-be-made-using-3d-printing-tech/cc5Qb4Nr
      case 'video':
        return <PostVideo {...this.props} advertorial={advertorial} />;
      // Poster: 40525480/the-marvel-studios-mind-set-for-making-hit-after-hit
      // Slideshow: 40537294/the-25-best-productivity-apps-for-2018
      default:
        return <PostDefault {...this.props} advertorial={advertorial} />;
    }
  }

  render() {
    const { posts, combinedAdModel } = this.props;
    const firstPost = get(posts, '[0]');
    const fullPageCeros = get(
      firstPost,
      'customFields.full_page_ceros_embed',
      false
    );
    const cerosEmbed = get(firstPost, 'customFields.ceros_embed', false);
    const advertorial = isAdvertorial(get(firstPost, 'tags', []));
    const advertorialFestival = this.isAdvertorialFestival(
      get(firstPost, 'tags', [])
    );
    const modifier = advertorial ? 'post__wrapper--advertorial' : '';
    const isMCP = get(firstPost, 'customFields.show_mcp_list', false);

    if (!firstPost) return null;

    const isList = !!(
      firstPost &&
      firstPost.customFields &&
      ((firstPost.customFields.list_article &&
        firstPost.customFields.list_article.is_list_article) ||
        firstPost.customFields.is_list)
    );
    return (
      <div
        // className={`video-megatron  ${modifier}`} // eslint-disable-line
        className={`post__wrapper  ${modifier}`}
        id={`post__wrapper-${firstPost.id}`}
      >
        {this.renderTopAds(firstPost, isList)}
        {advertorialFestival ? (
          <div className="post__advertorial-festival-banner">
            <div className="post__advertorial-festival-paid-content">
              PAID CONTENT
            </div>
            <div className="post__advertorial-festival-art">
              <img
                src="https://assets.fastcompany.com/image/upload/v1601492951/fcif_fascoworks-logo.svg"
                alt=""
              />
            </div>
          </div>
        ) : (
          ''
        )}
        {advertorial ? (
          <div className="advertorial-header-wrapper">
            <Sticky
              top={this.state.stickyOffset}
              bottomBoundary={`.sticky-boundry-${posts[0].id}`}
              enabled={false}
              activeClass="sticky"
              releasedClass="sticky__released"
            >
              <div className="advertorial-mobile-paid">
                <h2>PAID CONTENT</h2>
              </div>
              <div className="advertorial-border">
                <div className="advertorial-header">
                  <div className="advertorial-header__inner">
                    <div className="advertorial-header__brandworks-logo">
                      <img
                        src="https://images.fastcompany.net/image/upload/v1571242872/fcweb/FastCoWorks_branded_web_article_slug_fvfiy0.png"
                        alt="hey"
                      />
                    </div>
                    <div className="advertorial-header__brandworks-logo--collapsed advertorial-header__brandworks-logo--mobile">
                      <img
                        src="https://images.fastcompany.net/image/upload/v1571242872/fcweb/FastCoWorks_branded_web_article_slug_fvfiy0.png"
                        alt="hey2"
                      />
                    </div>
                    <div className="advertorial-header__brand-logo">
                      <Ad
                        {...combinedAdModel}
                        name="brandworkstop_mobile"
                        pageNum={1}
                        slug={false}
                      />
                      <Ad
                        {...combinedAdModel}
                        name="brandworkstop"
                        pageNum={1}
                        slug={false}
                      />
                    </div>
                    <div className="advertorial-header__paid">PAID CONTENT</div>
                  </div>
                </div>
              </div>
            </Sticky>
          </div>
        ) : (
          ''
        )}
        {/* <Ad {...combinedAdModel} name="oop" slug={false} oop={true} /> */}

        {fullPageCeros && cerosEmbed ? (
          <div dangerouslySetInnerHTML={{ __html: cerosEmbed }} />
        ) : (
          this.renderTemplate(firstPost, advertorial, isList, isMCP)
        )}
        {this.renderTrackerField()}
        <span className={`sticky-boundry-${posts[0].id}`} />
      </div>
    );
  }
}

PostsContainer.defaultProps = {
  isDesktop: false,
  isFirstPost: false,
  related: [],
  updateCorrelator: false,
  live: false
};

PostsContainer.propTypes = {
  config: PropTypes.shape({}).isRequired,
  posts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  related: PropTypes.arrayOf(PropTypes.shape({})),
  combinedAdModel: PropTypes.shape({}).isRequired,
  isDesktop: PropTypes.bool,
  isFirstPost: PropTypes.bool,
  videoAdData: PropTypes.shape({}).isRequired,
  pageNum: PropTypes.number.isRequired,
  updateCorrelator: PropTypes.bool,
  live: PropTypes.bool
};
